module.exports = __webpack_public_path__ + "static/media/step-three-big.1cf6b4bc.jpg";